import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useProductCategoryCreateMutation } from '@occc-app/dataAccessLayer/productCategory/mutations';
import { ProductCategoryCreateMutation } from '@occc/graphql';
import { useChainId } from '@occc-app/Chain/hooks';

import { CreateProductCategoryPage } from './CreateProductCategoryPage';

import { routeCreator } from '../utils';
import { ProductCategoryFormValues } from '../types';
import { validateProductCategory } from '../validation';

const initialValues: ProductCategoryFormValues = {
  categoryRestriction: 'None',
};

export const CreateProductCategoryPageContainer: React.FC = () => {
  const navigate = useNavigate();
  const chainId = useChainId();

  const onCompleted = (mutation: ProductCategoryCreateMutation) => {
    const id = mutation.productCategoryCreate?.id;

    if (id) {
      navigate(routeCreator.details(id));
    }
  };
  const [createProductCategoryMutation] = useProductCategoryCreateMutation({ onCompleted });

  const create = (values: ProductCategoryFormValues) => {
    const { name, rank, categoryRestriction } = values;

    if (!name) {
      return;
    }

    return createProductCategoryMutation({
      variables: {
        input: {
          name,
          rank,
          categoryRestriction: categoryRestriction === 'None' ? null : categoryRestriction,
          chainId,
        },
      },
    });
  };

  return (
    <CreateProductCategoryPage
      createProductCategory={create}
      validate={validateProductCategory}
      initialValues={initialValues}
    />
  );
};
